"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get _wherePk () {
        return _wherePk;
    },
    get applyPaginate () {
        return applyPaginate;
    },
    get checkColumnRequired () {
        return checkColumnRequired;
    },
    get concatKnexRaw () {
        return concatKnexRaw;
    },
    get dataWrapper () {
        return dataWrapper;
    },
    get extractIdPropIfObjectOrReturn () {
        return extractIdPropIfObjectOrReturn;
    },
    get extractIds () {
        return extractIds;
    },
    get extractSortsObject () {
        return extractSortsObject;
    },
    get formatDataForAudit () {
        return formatDataForAudit;
    },
    get generateRecursiveCTE () {
        return generateRecursiveCTE;
    },
    get getArrayAggExpression () {
        return getArrayAggExpression;
    },
    get getAs () {
        return getAs;
    },
    get getBaseModelSqlFromModelId () {
        return getBaseModelSqlFromModelId;
    },
    get getColumnName () {
        return getColumnName;
    },
    get getCompositePkValue () {
        return getCompositePkValue;
    },
    get getListArgs () {
        return getListArgs;
    },
    get getOppositeRelationType () {
        return getOppositeRelationType;
    },
    get getQueriedColumns () {
        return getQueriedColumns;
    },
    get getRelatedLinksColumn () {
        return getRelatedLinksColumn;
    },
    get haveFormulaColumn () {
        return haveFormulaColumn;
    },
    get isDataAuditEnabled () {
        return isDataAuditEnabled;
    },
    get isFilterValueConsistOf () {
        return isFilterValueConsistOf;
    },
    get isPrimitiveType () {
        return isPrimitiveType;
    },
    get nanoidv2 () {
        return nanoidv2;
    },
    get populatePk () {
        return populatePk;
    },
    get replaceDynamicFieldWithValue () {
        return replaceDynamicFieldWithValue;
    },
    get shouldSkipField () {
        return shouldSkipField;
    },
    get swaggerGetSourcePrefix () {
        return swaggerGetSourcePrefix;
    },
    get transformObject () {
        return transformObject;
    },
    get transformObjectKeys () {
        return transformObjectKeys;
    },
    get validateFuncOnColumn () {
        return validateFuncOnColumn;
    }
});
const _nanoid = require("nanoid");
const _nocodbsdk = require("nocodb-sdk");
const _uuid = require("uuid");
const _validator = /*#__PURE__*/ _interop_require_default(require("validator"));
const _stringHelpers = require("~/helpers/stringHelpers");
const _catchError = require("~/helpers/catchError");
const _extractLimitAndOffset = require("~/helpers/extractLimitAndOffset");
const _models = require("~/models");
const _utils = require("~/utils");
const _NcConnectionMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/utils/common/NcConnectionMgrv2"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function concatKnexRaw(knex, raws) {
    return knex.raw(raws.map(()=>'?').join(' '), raws);
}
function _wherePk(primaryKeys, id, skipPkValidation = false) {
    const where = {};
    // if id object is provided use as it is
    if (id && typeof id === 'object' && !Array.isArray(id)) {
        // verify all pk columns are present in id object
        for (const pk of primaryKeys){
            let key;
            if (pk.id in id) {
                key = pk.id;
            } else if (pk.title in id) {
                key = pk.title;
            } else if (pk.column_name in id) {
                key = pk.column_name;
            } else {
                _catchError.NcError.badRequest(`Primary key column ${pk.title} not found in id object`);
            }
            where[pk.column_name] = id[key];
            // validate value if auto-increment column
            // todo: add more validation based on column constraints
            if (!skipPkValidation && pk.ai && !/^\d+$/.test(id[key])) {
                _catchError.NcError.invalidPrimaryKey(id[key], pk.title);
            }
        }
        return where;
    }
    let ids = id;
    if (Array.isArray(id)) {
        ids = id;
    } else if (primaryKeys.length === 1) {
        ids = [
            id
        ];
    } else {
        ids = (id + '').split('___').map((val)=>val.replaceAll('\\_', '_'));
    }
    for(let i = 0; i < primaryKeys.length; ++i){
        var _parseProp;
        if (primaryKeys[i].dt === 'bytea') {
            // if column is bytea, then we need to encode the id to hex based on format
            // where[primaryKeys[i].column_name] =
            // (primaryKeys[i].meta?.format === 'hex' ? '\\x' : '') + ids[i];
            return (qb)=>{
                var _primaryKeys_i_meta;
                qb.whereRaw(`?? = decode(?, '${((_primaryKeys_i_meta = primaryKeys[i].meta) == null ? void 0 : _primaryKeys_i_meta.format) === 'hex' ? 'hex' : 'escape'}')`, [
                    primaryKeys[i].column_name,
                    ids[i]
                ]);
            };
        } else if ([
            _nocodbsdk.UITypes.Decimal,
            _nocodbsdk.UITypes.Number
        ].includes(primaryKeys[i].uidt) || _nocodbsdk.UITypes.ID === primaryKeys[i].uidt && !((_parseProp = (0, _nocodbsdk.parseProp)(primaryKeys[i].meta)) == null ? void 0 : _parseProp.ag)) {
            if (!(0, _nocodbsdk.ncIsNumber)(Number(ids[i]))) {
                if (!skipPkValidation) {
                    _catchError.NcError.invalidPrimaryKey(ids[i], primaryKeys[i].title);
                }
            }
            where[primaryKeys[i].column_name] = ids[i];
            continue;
        }
        // Cast the id to string.
        const idAsString = ids[i] + '';
        // Check if the id is a UUID and the column is binary(16)
        const isUUIDBinary16 = primaryKeys[i].ct === 'binary(16)' && (idAsString.length === 36 || idAsString.length === 32);
        // If the id is a UUID and the column is binary(16), convert the id to a Buffer. Otherwise, return null to indicate that the id is not a UUID.
        const idAsUUID = isUUIDBinary16 ? idAsString.length === 32 ? idAsString.replace(/(.{8})(.{4})(.{4})(.{4})(.{12})/, '$1-$2-$3-$4-$5') : idAsString : null;
        where[primaryKeys[i].column_name] = idAsUUID ? Buffer.from(idAsUUID.replace(/-/g, ''), 'hex') : ids[i];
    }
    return where;
}
function getCompositePkValue(primaryKeys, row, option) {
    var _row_primaryKeys__pkIdOrTitleKey;
    if (row === null || row === undefined) {
        _catchError.NcError.requiredFieldMissing(primaryKeys.map((c)=>(option == null ? void 0 : option.skipSubstitutingColumnIds) ? c.id : c.title).join(','));
    }
    if (typeof row !== 'object') return row;
    const pkIdOrTitleKey = (option == null ? void 0 : option.skipSubstitutingColumnIds) ? 'id' : 'title';
    if (primaryKeys.length > 1) {
        return primaryKeys.map((c)=>{
            var _row_c_pkIdOrTitleKey;
            var _toString, _this;
            return (_this = (_row_c_pkIdOrTitleKey = row[c[pkIdOrTitleKey]]) != null ? _row_c_pkIdOrTitleKey : row[c.column_name]) == null ? void 0 : (_toString = _this.toString) == null ? void 0 : _toString.call(_this).replaceAll('_', '\\_');
        }).join('___');
    }
    return primaryKeys[0] && ((_row_primaryKeys__pkIdOrTitleKey = row[primaryKeys[0][pkIdOrTitleKey]]) != null ? _row_primaryKeys__pkIdOrTitleKey : row[primaryKeys[0].column_name]);
}
function getOppositeRelationType(type) {
    if (type === _nocodbsdk.RelationTypes.HAS_MANY) {
        return _nocodbsdk.RelationTypes.BELONGS_TO;
    } else if (type === _nocodbsdk.RelationTypes.BELONGS_TO) {
        return _nocodbsdk.RelationTypes.HAS_MANY;
    } else if (type === _nocodbsdk.RelationTypes.ONE_TO_MANY) {
        return _nocodbsdk.RelationTypes.MANY_TO_ONE;
    } else if (type === _nocodbsdk.RelationTypes.MANY_TO_ONE) {
        return _nocodbsdk.RelationTypes.ONE_TO_MANY;
    }
    return type;
}
async function getBaseModelSqlFromModelId({ modelId, context, options = {} }) {
    const model = await _models.Model.get(context, modelId);
    const source = await _models.Source.get(context, model.source_id);
    return await _models.Model.getBaseModelSQL(context, {
        id: model.id,
        dbDriver: await _NcConnectionMgrv2.default.get(source),
        transaction: options == null ? void 0 : options.transaction,
        viewId: options == null ? void 0 : options.viewId,
        source
    });
}
function isDataAuditEnabled() {
    return process.env.NC_DISABLE_AUDIT !== 'true';
}
function getRelatedLinksColumn(column, relatedModel) {
    return relatedModel.columns.find((c)=>{
        var _column_colOptions;
        if (((_column_colOptions = column.colOptions) == null ? void 0 : _column_colOptions.type) === _nocodbsdk.RelationTypes.MANY_TO_MANY) {
            var _c_colOptions, _c_colOptions1;
            return column.colOptions.fk_mm_child_column_id === ((_c_colOptions = c.colOptions) == null ? void 0 : _c_colOptions.fk_mm_parent_column_id) && column.colOptions.fk_mm_parent_column_id === ((_c_colOptions1 = c.colOptions) == null ? void 0 : _c_colOptions1.fk_mm_child_column_id);
        } else {
            var _c_colOptions2, _c_colOptions3;
            return column.colOptions.fk_child_column_id === ((_c_colOptions2 = c.colOptions) == null ? void 0 : _c_colOptions2.fk_child_column_id) && column.colOptions.fk_parent_column_id === ((_c_colOptions3 = c.colOptions) == null ? void 0 : _c_colOptions3.fk_parent_column_id);
        }
    });
}
function extractIdPropIfObjectOrReturn(id, prop) {
    return typeof id === 'object' ? id[prop] : id;
}
const nanoidv2 = (0, _nanoid.customAlphabet)('1234567890abcdefghijklmnopqrstuvwxyz', 14);
async function populatePk(context, model, insertObj) {
    await model.getColumns(context);
    for (const pkCol of model.primaryKeys){
        var _pkCol_meta, _pkCol_meta1;
        if (!((_pkCol_meta = pkCol.meta) == null ? void 0 : _pkCol_meta.ag) || insertObj[pkCol.title]) continue;
        insertObj[pkCol.title] = ((_pkCol_meta1 = pkCol.meta) == null ? void 0 : _pkCol_meta1.ag) === 'nc' ? `rc_${nanoidv2()}` : (0, _uuid.v4)();
    }
}
function checkColumnRequired(column, fields, extractPkAndPv) {
    // if primary key or foreign key included in fields, it's required
    if (column.pk || column.uidt === _nocodbsdk.UITypes.ForeignKey) return true;
    if (extractPkAndPv && column.pv) return true;
    // check fields defined and if not, then select all
    // if defined check if it is in the fields
    return !fields || fields.includes(column.title);
}
async function getColumnName(context, column, columns) {
    if (!(0, _nocodbsdk.isCreatedOrLastModifiedTimeCol)(column) && !(0, _nocodbsdk.isCreatedOrLastModifiedByCol)(column) && !(0, _nocodbsdk.isOrderCol)(column)) return column.column_name;
    columns = columns || await _models.Column.list(context, {
        fk_model_id: column.fk_model_id
    });
    switch(column.uidt){
        case _nocodbsdk.UITypes.CreatedTime:
            {
                const createdTimeSystemCol = columns.find((col)=>col.system && col.uidt === _nocodbsdk.UITypes.CreatedTime);
                if (createdTimeSystemCol) return createdTimeSystemCol.column_name;
                return column.column_name || 'created_at';
            }
        case _nocodbsdk.UITypes.LastModifiedTime:
            {
                const lastModifiedTimeSystemCol = columns.find((col)=>col.system && col.uidt === _nocodbsdk.UITypes.LastModifiedTime);
                if (lastModifiedTimeSystemCol) return lastModifiedTimeSystemCol.column_name;
                return column.column_name || 'updated_at';
            }
        case _nocodbsdk.UITypes.CreatedBy:
            {
                const createdBySystemCol = columns.find((col)=>col.system && col.uidt === _nocodbsdk.UITypes.CreatedBy);
                if (createdBySystemCol) return createdBySystemCol.column_name;
                return column.column_name || 'created_by';
            }
        case _nocodbsdk.UITypes.LastModifiedBy:
            {
                const lastModifiedBySystemCol = columns.find((col)=>col.system && col.uidt === _nocodbsdk.UITypes.LastModifiedBy);
                if (lastModifiedBySystemCol) return lastModifiedBySystemCol.column_name;
                return column.column_name || 'updated_by';
            }
        case _nocodbsdk.UITypes.Order:
            {
                const orderSystemCol = columns.find((col)=>col.system && col.uidt === _nocodbsdk.UITypes.Order);
                if (orderSystemCol) return orderSystemCol.column_name;
                return column.column_name || 'nc_order';
            }
        default:
            return column.column_name;
    }
}
function getAs(column) {
    return column.asId || column.id;
}
function replaceDynamicFieldWithValue(_row, _rowId, _tableColumns, _readByPk, _queryParams) {
    const replaceWithValue = async (conditions)=>{
        return conditions;
    };
    return replaceWithValue;
}
const isPrimitiveType = (val)=>typeof val === 'string' || typeof val === 'number';
function transformObject(value, idToAliasMap) {
    if ((0, _nocodbsdk.ncIsNullOrUndefined)(value)) {
        return value;
    }
    const result = {};
    Object.entries(value).forEach(([k, v])=>{
        const btAlias = idToAliasMap[k];
        if (btAlias) {
            result[btAlias] = v;
        } else {
            result[k] = v;
        }
    });
    return result;
}
function extractSortsObject(context, _sorts, aliasColObjMap, throwErrorIfInvalid = false, apiVersion) {
    if (!(_sorts == null ? void 0 : _sorts.length)) return;
    // Handle API V3 format: [{"direction": "asc", "field": "field_name"}, {"direction": "desc", "field": "field_id"}]
    if (apiVersion === _nocodbsdk.NcApiVersion.V3) {
        try {
            _sorts = JSON.parse(_sorts);
        } catch (_e) {}
        if (!Array.isArray(_sorts)) _sorts = [
            _sorts
        ];
        return _sorts.map((s)=>{
            var _aliasColObjMap_s_field;
            const sort = {
                direction: s.direction,
                fk_column_id: (_aliasColObjMap_s_field = aliasColObjMap[s.field]) == null ? void 0 : _aliasColObjMap_s_field.id
            };
            if (throwErrorIfInvalid && !sort.fk_column_id) {
                _catchError.NcError.get(context).fieldNotFound(s.field);
            }
            return new _models.Sort(sort);
        });
    }
    // Handle V2 format
    let sorts = _sorts;
    if (!Array.isArray(sorts)) sorts = sorts.split(/\s*,\s*/);
    return sorts.map((s)=>{
        const sort = {
            direction: 'asc'
        };
        if (s.startsWith('-')) {
            var _aliasColObjMap_s_slice;
            sort.direction = 'desc';
            sort.fk_column_id = (_aliasColObjMap_s_slice = aliasColObjMap[s.slice(1)]) == null ? void 0 : _aliasColObjMap_s_slice.id;
        } else if (s.startsWith('~-')) {
            var _aliasColObjMap_s_slice1;
            sort.direction = 'count-desc';
            sort.fk_column_id = (_aliasColObjMap_s_slice1 = aliasColObjMap[s.slice(2)]) == null ? void 0 : _aliasColObjMap_s_slice1.id;
        } else if (s.startsWith('~+')) {
            var _aliasColObjMap_s_slice2;
            sort.direction = 'count-asc';
            sort.fk_column_id = (_aliasColObjMap_s_slice2 = aliasColObjMap[s.slice(2)]) == null ? void 0 : _aliasColObjMap_s_slice2.id;
        } else {
            var _aliasColObjMap_s_replace;
            sort.fk_column_id = (_aliasColObjMap_s_replace = aliasColObjMap[s.replace(/^\+/, '')]) == null ? void 0 : _aliasColObjMap_s_replace.id;
        }
        if (throwErrorIfInvalid && !sort.fk_column_id) {
            const fieldNameOrId = s.replace(/^~?[+-]/, '');
            _catchError.NcError.get(context).fieldNotFound(fieldNameOrId);
        }
        return new _models.Sort(sort);
    });
}
function applyPaginate(query, { limit = 25, offset = 0, ignoreLimit = false }) {
    query.offset(offset);
    if (!ignoreLimit) query.limit(limit);
    return query;
}
function haveFormulaColumn(columns) {
    return columns.some((c)=>c.uidt === _nocodbsdk.UITypes.Formula);
}
function shouldSkipField(fieldsSet, viewOrTableColumn, view, column, extractPkAndPv, pkAndPvOnly = false) {
    // skip row meta column
    if (column.uidt === _nocodbsdk.UITypes.Meta) return true;
    if (fieldsSet && !pkAndPvOnly) {
        return !fieldsSet.has(column.title) && !fieldsSet.has(column.id);
    } else {
        if (!pkAndPvOnly && column.system && (0, _nocodbsdk.isCreatedOrLastModifiedByCol)(column)) return true;
        if (!pkAndPvOnly && column.system && (0, _nocodbsdk.isOrderCol)(column)) return true;
        if (!extractPkAndPv) {
            if (!(viewOrTableColumn instanceof _models.Column)) {
                if (!(viewOrTableColumn == null ? void 0 : viewOrTableColumn.show) && !(column.rqd && !column.cdf && !column.ai) && !column.pk && column.uidt !== _nocodbsdk.UITypes.ForeignKey) return true;
                if (!(view == null ? void 0 : view.show_system_fields) && column.uidt !== _nocodbsdk.UITypes.ForeignKey && !column.pk && (0, _nocodbsdk.isSystemColumn)(column)) return true;
            }
        }
        // skip all other columns if pkAndPvOnly passed as true
        if (pkAndPvOnly && !column.pk && !column.pv) return true;
        return false;
    }
}
async function getQueriedColumns(context, { model, fieldsSet, view, extractPkAndPv, pkAndPvOnly }, ncMeta) {
    let viewOrTableColumns;
    const _columns = await model.getColumns(context, ncMeta);
    if (fieldsSet == null ? void 0 : fieldsSet.size) {
        viewOrTableColumns = _columns;
    } else {
        const viewColumns = (view == null ? void 0 : view.id) && await _models.View.getColumns(context, view.id);
        // const columns = _columns ?? (await baseModel.model.getColumns(baseModel.context));
        // for (const column of columns) {
        viewOrTableColumns = viewColumns.map((viewColumn)=>_columns.find((col)=>col.id === viewColumn.fk_column_id)) || _columns;
    }
    return viewOrTableColumns.filter((viewOrTableColumn)=>!shouldSkipField(fieldsSet, viewOrTableColumn, view, viewOrTableColumn, extractPkAndPv || pkAndPvOnly, pkAndPvOnly));
}
function getListArgs(args, model, { ignoreAssigningWildcardSelect = false, apiVersion = _nocodbsdk.NcApiVersion.V2, nested = false } = {}) {
    var _model_primaryKey_, _model_primaryKey;
    const obj = {};
    obj.where = args.where || args.filter || args.w || '';
    obj.having = args.having || args.h || '';
    obj.shuffle = args.shuffle || args.r || '';
    obj.condition = args.condition || args.c || {};
    obj.conditionGraph = args.conditionGraph || {};
    obj.page = args.page || args.p;
    if (apiVersion === _nocodbsdk.NcApiVersion.V3 && nested) {
        if (args.nestedLimit) {
            obj.limit = obj.limit = Math.max(Math.min(Math.max(+args.nestedLimit, 0) || _extractLimitAndOffset.defaultLimitConfig.limitDefault, _extractLimitAndOffset.defaultLimitConfig.limitMax), _extractLimitAndOffset.defaultLimitConfig.limitMin);
        } else {
            obj.limit = _extractLimitAndOffset.defaultLimitConfig.ltarV3Limit;
        }
    } else {
        obj.limit = Math.max(Math.min(Math.max(+((args == null ? void 0 : args.limit) || (args == null ? void 0 : args.l)), 0) || _extractLimitAndOffset.defaultLimitConfig.limitDefault, _extractLimitAndOffset.defaultLimitConfig.limitMax), _extractLimitAndOffset.defaultLimitConfig.limitMin);
    }
    obj.offset = Math.max(+((args == null ? void 0 : args.offset) || (args == null ? void 0 : args.o)) || 0, 0);
    if (obj.page) {
        obj.offset = (+obj.page - 1) * +obj.limit;
    }
    if (!(0, _nocodbsdk.ncIsNumber)(Number(obj.offset)) || Number(obj.offset) < 0) {
        _catchError.NcError.invalidOffsetValue(obj.offset);
    }
    obj.fields = (args == null ? void 0 : args.fields) || (args == null ? void 0 : args.f) || (ignoreAssigningWildcardSelect ? null : '*');
    obj.sort = (args == null ? void 0 : args.sort) || (args == null ? void 0 : args.s) || ((_model_primaryKey = model.primaryKey) == null ? void 0 : (_model_primaryKey_ = _model_primaryKey[0]) == null ? void 0 : _model_primaryKey_.column_name);
    obj.pks = args == null ? void 0 : args.pks;
    obj.aggregation = args.aggregation || [];
    obj.column_name = args.column_name;
    return obj;
}
function extractIds(childIds, isBt = false) {
    return (isBt ? childIds.slice(0, 1) : childIds).map((r)=>typeof r === 'object' ? JSON.stringify(r) : `${r}`);
}
function formatDataForAudit(data, columns) {
    if (!data || typeof data !== 'object') return data;
    const res = {};
    for (const column of columns){
        if ((0, _nocodbsdk.isSystemColumn)(column) || (0, _nocodbsdk.isVirtualCol)(column)) continue;
        if (!(column.title in data)) {
            continue;
        }
        res[column.title] = data[column.title];
        // if multi-select column, convert string to array
        if (column.uidt === _nocodbsdk.UITypes.MultiSelect) {
            if (res[column.title] && typeof res[column.title] === 'string') {
                res[column.title] = res[column.title].split(',');
            }
        } else if (column.uidt === _nocodbsdk.UITypes.Attachment) {
            if (res[column.title] && Array.isArray(res[column.title])) {
                try {
                    res[column.title] = res[column.title].map((attachment)=>(0, _utils.excludeAttachmentProps)(attachment));
                } catch (unused) {
                // ignore
                }
            }
        }
    }
    return res;
}
const validateFuncOnColumn = async ({ value, column, apiVersion = _nocodbsdk.NcApiVersion.V2, customValidators = {} })=>{
    var _column_meta;
    if ((column == null ? void 0 : (_column_meta = column.meta) == null ? void 0 : _column_meta.validate) && (column == null ? void 0 : column.validate)) {
        const validate = column.getValidators();
        const columnTitle = column.title;
        if (validate) {
            const { func, msg } = validate;
            for(let j = 0; j < func.length; ++j){
                let fn = func[j];
                if (typeof func[j] === 'string') {
                    var _customValidators_func_j;
                    fn = (_customValidators_func_j = customValidators[func[j]]) != null ? _customValidators_func_j : _validator.default[func[j]];
                }
                const columnValue = value;
                const arg = typeof func[j] === 'string' ? columnValue + '' : columnValue;
                if (![
                    null,
                    undefined,
                    ''
                ].includes(columnValue) && !(fn.constructor.name === 'AsyncFunction' ? await fn(arg) : fn(arg))) {
                    if (apiVersion === _nocodbsdk.NcApiVersion.V3) {
                        _catchError.NcError.invalidValueForField({
                            value: columnValue,
                            type: column.uidt,
                            column: column.title
                        });
                    }
                    _catchError.NcError.badRequest(msg[j].replace(/\{VALUE}/g, columnValue).replace(/\{cn}/g, columnTitle));
                }
            }
        }
    }
};
const isFilterValueConsistOf = (filterValue, needle, option)=>{
    const evalNeedle = needle.toLowerCase().trim();
    if (Array.isArray(filterValue)) {
        const arr = filterValue;
        const result = arr.some((k)=>k.toLowerCase().trim() === evalNeedle);
        if (result && (option == null ? void 0 : option.replace)) {
            const replaced = arr.map((k)=>k.toLowerCase().trim() === evalNeedle ? option.replace : k);
            return {
                exists: true,
                value: replaced
            };
        }
        return {
            exists: result,
            value: filterValue
        };
    }
    if (typeof filterValue === 'string') {
        const parts = filterValue.split(',');
        const result = parts.some((k)=>k.toLowerCase().trim() === evalNeedle);
        if (result && (option == null ? void 0 : option.replace)) {
            const replaced = parts.map((k)=>k.toLowerCase().trim() === evalNeedle ? option.replace : k).join(',');
            return {
                exists: true,
                value: replaced
            };
        }
        return {
            exists: result,
            value: filterValue
        };
    }
    return {
        exists: false
    };
};
function generateRecursiveCTE(_params) {
    return false;
}
const dataWrapper = (data)=>{
    return {
        getByColumnNameTitleOrId: (column)=>{
            if (column.column_name in data) {
                return data[column.column_name];
            }
            if (column.title in data) {
                return data[column.title];
            }
            if (column.id in data) {
                return data[column.id];
            }
            return undefined;
        },
        getColumnKeyName: (column)=>{
            if (!(0, _nocodbsdk.ncIsNullOrUndefined)(data == null ? void 0 : data[column.column_name])) {
                return column.column_name;
            }
            if (!(0, _nocodbsdk.ncIsNullOrUndefined)(data == null ? void 0 : data[column.title])) {
                return column.title;
            }
            return column.id;
        },
        extractPksValue: (model, asString = false)=>{
            // if data is not object return as it is
            if (!data || typeof data !== 'object') {
                if (asString && !(0, _nocodbsdk.ncIsNull)(data) && !(0, _nocodbsdk.ncIsUndefined)(data)) {
                    return `${data}`;
                }
                return data;
            }
            // data can be still inserted without PK
            // if composite primary key return an object with all the primary keys
            if (model.primaryKeys.length > 1) {
                const pkValues = {};
                for (const pk of model.primaryKeys){
                    var _ref, _data_pk_title;
                    pkValues[pk.title] = (_ref = (_data_pk_title = data[pk.title]) != null ? _data_pk_title : data[pk.column_name]) != null ? _ref : data[pk.id];
                }
                return asString ? Object.values(pkValues).map((val)=>{
                    var _val_toString;
                    return val == null ? void 0 : (_val_toString = val.toString) == null ? void 0 : _val_toString.call(val).replaceAll('_', '\\_');
                }).join('___') : pkValues;
            } else if (model.primaryKey) {
                let pkValue;
                if (typeof data === 'object') {
                    var _ref1, _data_model_primaryKey_title;
                    pkValue = (_ref1 = (_data_model_primaryKey_title = data[model.primaryKey.title]) != null ? _data_model_primaryKey_title : data[model.primaryKey.column_name]) != null ? _ref1 : data[model.primaryKey.id];
                } else {
                    pkValue = data;
                }
                if (pkValue !== undefined) return asString ? `${pkValue}` : pkValue;
            } else {
                return 'N/A';
            }
        }
    };
};
function transformObjectKeys(obj, aliasMap) {
    if (!obj || typeof obj !== 'object') return obj;
    const result = {};
    Object.entries(obj).forEach(([key, value])=>{
        const alias = aliasMap[key];
        result[alias || key] = value;
    });
    return result;
}
function getArrayAggExpression(knex, knexConnection, columnName, alias) {
    const client = knexConnection.client.config.client;
    // Note: columnName and alias are controlled by our code, so it's safe to use directly
    const exprMap = {
        pg: `ARRAY_AGG(DISTINCT ${columnName}) FILTER (WHERE ${columnName} IS NOT NULL) AS ${alias}`,
        mysql2: `JSON_ARRAYAGG(DISTINCT ${columnName}) AS ${alias}`,
        sqlite3: `json_group_array(DISTINCT ${columnName}) AS ${alias}`
    };
    // fallback to mysql2 query
    return knex.raw(exprMap[client] || exprMap.mysql2);
}
function swaggerGetSourcePrefix(source) {
    return (source == null ? void 0 : source.isMeta()) ? '' : `${(0, _stringHelpers.swaggerSanitizeSchemaName)((source == null ? void 0 : source.alias) || 'Source')}_`;
}
